export const PALETTE = {
    darkGreen: "#626F47",
    midGreen: "#A4B465",
    darkerGreen: "#313822",
    darkestGreen: "#1E2316",
    deepGreen: "#1a1e12",

    cream: "#F5ECD5",
    gold: "#F0BB78",
    earthBrown: "#8B572A",

    lightGray: "#A0A0A0",
    zinc600: "#52525b",
    stoneButton: "#262D1C",

    errorRed: "#ef4444",
    deleteRed: "#A43A3A",
};